// import { API } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ContainerContent from "../../Container/ContainerContent";
import LoadingPage from "../../Loading/LoadingPage";
import GroupTable from "./leasing.f.groupTable";
import { Dialog } from "@headlessui/react";
import { Tabs, Tab } from "../../BuroBug/layer/wrapper";
import { IconDashboard, IconList } from "../../BuroBug/layer/wrapper";
import classNames from "classnames";
import API from "../api/api.main"


const Groups = ({ type, category, label }) => {
  const [loading, setLoading] = useState(true);
  const [carGroups, setCarGroups] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [formAdd, setFormAdd] = useState(false);
  const [error, setError] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [indexAdd, setIndexAdd] = useState(-1);
  const [idGroup, setIdGroup] = useState("");
  const [isAddYear, setIsAddYear] = useState(false);
  const [loadingAddYear, setLoadingAddYear] = useState(false);
  const [year, setYear] = useState("");

  useEffect(() => {
    fetchCarData();
  }, []);

  const fetchCarData = async () => {
    try {
      setLoading(true);
      const carGroups = await API.get("MoneyHubAdmin", `/leasing/group`, {
        queryStringParameters: {
          type,
          category,
        },
      });
      setCarGroups(carGroups?.groups.sort((a, b) => a?.sort - b?.sort));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onClickAdd = async () => {
    try {
      setLoadingAdd(true);
      if (indexAdd >= 0) {
        await API.put("MoneyHubAdmin", `/leasing/group/${idGroup}`, {
          body: {
            type: carGroups[indexAdd].type,
            category: carGroups[indexAdd].category,
            years: carGroups[indexAdd].years,
            groups: [...carGroups[indexAdd].groups, formAdd],
          },
        });
      } else {
        await API.post("MoneyHubAdmin", `/leasing/group`, {
          body: {
            type,
            category,
            years: [],
            groups: [formAdd],
          },
        });
      }

      setOpenAddModal(false);
      setFormAdd({});
      setIndexAdd(-1);
      await fetchCarData();
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingAdd(false);
    }
  };

  const onClickAddYear = async (id, index) => {
    try {
      setLoadingAdd(true);
      await API.put("MoneyHubAdmin", `/leasing/group/${id}`, {
        body: {
          type: carGroups[index].type,
          category: carGroups[index].category,
          years: [...carGroups[index].years, year],
          groups: [...carGroups[index].groups],
        },
      });
      setIndexAdd(index);
      setIsAddYear(false);
      setOpenAddModal(false);
      setYear("");
      await fetchCarData();
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingAdd(false);
    }
  };

  const onClickDeleteYear = async (id, index, indexYear) => {
    try {
      setLoadingAdd(true);
      carGroups[index].years.splice(indexYear, 1);
      await API.put("MoneyHubAdmin", `/leasing/group/${id}`, {
        body: {
          type: carGroups[index].type,
          category: carGroups[index].category,
          years: carGroups[index].years,
          groups: [...carGroups[index].groups],
        },
      });
      setOpenAddModal(false);
      setYear("");
      await fetchCarData();
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingAdd(false);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="flex flex-col">
      <div className=" inline-block py-2 px-6">
        <div className="flex items-center">
          <div className="text-lg">{label}</div>
          <button
            onClick={() => {
              setOpenAddModal(true);
            }}
            className="flex items-center justify-center px-2 py-1 bg-blue-500 text-white rounded mt-2 ml-2 text-sm"
          >
            เพิ่มกรุ๊ป
          </button>
        </div>

        {carGroups.map((carGroup, index) => {
          return (
            <div key={index} className="mt-6">
              <div className="flex items-center mb-2">
                <div>{index + 1}. กลุ่มปีรถ</div>
                {carGroup?.years.map((year, indexYear) => {
                  return (
                    <div
                      key={indexYear}
                      className="py-1 px-1 bg-gray-300 text-white ml-2 rounded-lg flex items-center space-x-1"
                    >
                      <div className="ml-2">{year}</div>
                      <div
                        onClick={() =>
                          onClickDeleteYear(carGroup.id, index, indexYear)
                        }
                        className="text-red-600 cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-3 h-3"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </div>
                    </div>
                  );
                })}

                {isAddYear && indexAdd === index && (
                  <div className="ml-2 flex space-x-2">
                    <input
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      className="border border-gray-300 focus:outline-none px-2 py-1 rounded"
                      type="text"
                    />
                    <button
                      onClick={() => onClickAddYear(carGroup.id, index)}
                      className="flex items-center justify-center px-2 py-2 bg-green-500 text-white w-full rounded"
                    >
                      บันทึก
                    </button>
                    <button
                      onClick={() => {
                        setIsAddYear(false);
                        setYear("");
                      }}
                      className="flex items-center justify-center px-2 py-2 bg-red-500 text-white w-full rounded"
                    >
                      ยกเลิก
                    </button>
                  </div>
                )}
                {!isAddYear && (
                  <button
                    onClick={() => {
                      setIsAddYear(true);
                      setIndexAdd(index);
                    }}
                    className="flex items-center justify-center px-2 py-1 bg-green-500 text-white ml-2 rounded"
                  >
                    เพิ่มปีรถ
                  </button>
                )}
              </div>
              <GroupTable
                parentData={carGroups}
                data={carGroup?.groups}
                getData={fetchCarData}
                where={{}}
                groupIndex={index}
              />
              <button
                onClick={() => {
                  setIndexAdd(index);
                  setOpenAddModal(true);
                  setIdGroup(carGroup.id);
                }}
                className="flex items-center justify-center px-2 py-2 bg-green-500 text-white w-full rounded"
              >
                เพิ่มข้อมูล
              </button>
            </div>
          );
        })}
      </div>
      <div className="px-6">
        <Dialog
          open={openAddModal}
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={() => setOpenAddModal(false)}
        >
          <div className="flex items-center justify-center min-h-screen">
            <div className="bg-white border border-gray-300 rounded max-w-sm mx-auto p-4 z-20">
              <Dialog.Title className="font-black text-lg">
                เพิ่มกรุ๊ป
              </Dialog.Title>
              <Dialog.Description className="my-4">
                <div className="">
                  {[
                    { label: "Grade", name: "grade", type: "text" },
                    {
                      label: "กลุ่มลูกค้า",
                      name: "description",
                      type: "text",
                      tag: "textarea",
                    },
                    { label: "ltv", name: "ltv", type: "number" },
                  ].map((item, index) => {
                    return (
                      <div key={index} className="mb-2">
                        {" "}
                        <div>{item?.label}</div>
                        {item?.tag === "textarea" ? (
                          <textarea
                            className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                            type={item?.type ? item?.type : "number"}
                            name={item.name}
                            value={formAdd[item?.name]}
                            onChange={(e) =>
                              setFormAdd({
                                ...formAdd,
                                [item?.name]: e.target.value,
                              })
                            }
                          />
                        ) : (
                          <input
                            className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                            type={item?.type ? item?.type : "number"}
                            name={item.name}
                            value={formAdd[item?.name]}
                            onChange={(e) =>
                              setFormAdd({
                                ...formAdd,
                                [item?.name]: e.target.value,
                              })
                            }
                          />
                        )}
                        <span className="text-red-400 mx-2">
                          {error && !formAdd[item.name] && "โปรดใส่รายละเอียด"}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </Dialog.Description>
              <button
                disabled={loadingAdd}
                className={classNames("p-2 text-white w-20 mr-4 rounded", {
                  "bg-gray-400 cursor-not-allowed": loadingAdd,
                  "bg-blue-500": !loadingAdd,
                })}
                onClick={onClickAdd}
              >
                ตกลง
              </button>
              <button
                className="p-2 text-blue-500 border border-blue-500 w-20 rounded"
                onClick={() => setOpenAddModal(false)}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default Groups